import { WsVideoCodec } from "@screenView/types";

const evdevMappings: Record<string, number | null> = {
    Escape: 1,
    Backspace: 14,
    Tab: 15,
    Enter: 28,
    Space: 57,
    CapsLock: 58,
    Pause: 119,

    ShiftLeft: 42,
    ShiftRight: 54,
    ControlLeft: 29,
    ControlRight: 97,
    AltLeft: 56,
    AltRight: 100,
    MetaLeft: 125,
    MetaRight: 126,
    ContextMenu: 127,

    Digit1: 2,
    Digit2: 3,
    Digit3: 4,
    Digit4: 5,
    Digit5: 6,
    Digit6: 7,
    Digit7: 8,
    Digit8: 9,
    Digit9: 10,
    Digit0: 11,

    KeyA: 30,
    KeyB: 48,
    KeyC: 46,
    KeyD: 32,
    KeyE: 18,
    KeyF: 33,
    KeyG: 34,
    KeyH: 35,
    KeyI: 23,
    KeyJ: 36,
    KeyK: 37,
    KeyL: 38,
    KeyM: 50,
    KeyN: 49,
    KeyO: 24,
    KeyP: 25,
    KeyQ: 16,
    KeyR: 19,
    KeyS: 31,
    KeyT: 20,
    KeyU: 22,
    KeyV: 47,
    KeyW: 17,
    KeyX: 45,
    KeyY: 21,
    KeyZ: 44,

    Minus: 12,
    Equal: 13,
    BracketLeft: 26,
    BracketRight: 27,
    Semicolon: 39,
    Quote: 40,
    Backquote: 41,
    Backslash: 43,
    Comma: 51,
    Period: 52,
    Slash: 53,
    IntlBackslash: 86,

    F1: 59,
    F2: 60,
    F3: 61,
    F4: 62,
    F5: 63,
    F6: 64,
    F7: 65,
    F8: 66,
    F9: 67,
    F10: 68,
    F11: 87,
    F12: 88,
    F13: 183,
    F14: 184,
    F15: 185,
    F16: 186,
    F17: 187,
    F18: 188,
    F19: 189,
    F20: 190,
    F21: 191,
    F22: 192,
    F23: 193,
    F24: 194,

    Insert: 110,
    Delete: 111,
    Home: 102,
    End: 107,
    PageUp: 104,
    PageDown: 109,
    ArrowUp: 103,
    ArrowDown: 108,
    ArrowLeft: 105,
    ArrowRight: 106,

    NumLock: 69,
    ScrollLock: 70,

    Numpad0: 82,
    Numpad1: 79,
    Numpad2: 80,
    Numpad3: 81,
    Numpad4: 75,
    Numpad5: 76,
    Numpad6: 77,
    Numpad7: 71,
    Numpad8: 72,
    Numpad9: 73,
    NumpadDecimal: 83,
    NumpadAdd: 78,
    NumpadSubtract: 74,
    NumpadMultiply: 55,
    NumpadDivide: 98,
    NumpadEnter: 96,
    NumpadComma: 121,

    AudioVolumeMute: 113,
    AudioVolumeDown: 114,
    AudioVolumeUp: 115,
    VolumeMute: 113,
    MediaTrackPrevious: 165,
    MediaTrackNext: 163,
    MediaPlayPause: 164,
    MediaStop: 166,

    BrowserHome: 172,
    BrowserSearch: 217,
    BrowserFavorites: 156,
    BrowserRefresh: 173,
    BrowserStop: 128,
    BrowserForward: 159,
    BrowserBack: 158,

    LaunchApp1: 148,
    LaunchApp2: 149,
    LaunchMail: 155,
    MediaSelect: 226,

    PrintScreen: 99,
    Sleep: 142,
    Help: 138,

    Unidentified: null,
    NumpadEqual: null,
    IntlYen: null,
    IntlRo: null,
    Convert: null,
    NonConvert: null,
    KanaMode: null,
    Lang1: null,
    Lang2: null,
    Power: null,
    WakeUp: null,
    Undo: null,
    Paste: null,
    Cut: null,
    Copy: null,
    Eject: null,
    Fn: null,
    Again: null,
    Props: null,
    Select: null,
    Open: null,
    Find: null,
};
export function keyStringToEvdevKeycode(key: string): number | null {
    return evdevMappings[key] ?? null;
}

export function codecToWebCodecsString(codec: number): string {
    switch (codec) {
        case WsVideoCodec.H264:
            return "avc1.4d0033";
        case WsVideoCodec.H264High444:
            return "avc1.640032";
        case WsVideoCodec.H265:
            return "hvc1.1.6.L120.90";
        case WsVideoCodec.H265Main10:
            return "hvc1.2.4.L120.90";
        case WsVideoCodec.H265Rext8_444:
            return "hvc1.4.10.L120.90";
        case WsVideoCodec.H265Rext10_444:
            return "hvc1.4.10.L120.90";
        case WsVideoCodec.Av1Main8:
            return "av01.0.08M.08";
        case WsVideoCodec.Av1Main10:
            return "av01.0.08M.10";
        case WsVideoCodec.Av1High8_444:
            return "av01.1.08H.08";
        case WsVideoCodec.Av1High10_444:
            return "av01.1.08H.10";
        case WsVideoCodec.Vp8:
            return "vp8";
        case WsVideoCodec.Vp9:
            return "vp09.00.10.08";
        default:
            return "avc1.4d0033";
    }
}
